import {paneSvg as Icon__small__paneSvg} from '../Icon__small/Icon__small--pane.js';

export var pane = {
  name: 'pane',
  category: 'icon',
  colorable: true,
  svg: Icon__small__paneSvg,
};
